import { configureStore } from "@reduxjs/toolkit";
import FilterReducer from "./filterSlice";
import JoblistReducer from "./jobListSlice";
import OtherDataReducer from "./OtherDataSlice";

const store = configureStore({
	reducer: {
		FilterData: FilterReducer,
		JoblistData: JoblistReducer,
		OtherData: OtherDataReducer,
	},
	devTools : process.env.NODE_ENV !== 'production',
});

export default store;
